import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectNavigationSection: {
		id: 'command-palette-integration.controllers.use-register-sections.project-navigation-section',
		defaultMessage: 'Project navigation',
		description:
			'Command Palette section name, used to group project navigation commands like Go to backlog, board, reports and timeline',
	},
	siteNavigationSection: {
		id: 'command-palette-integration.controllers.use-register-sections.site-navigation-section',
		defaultMessage: 'Site navigation',
		description:
			'Command Palette section name, used to group site navigation commands like Go to all boards, projects, filters, etc',
	},
	quickActionsSection: {
		id: 'command-palette-integration.controllers.use-register-sections.quick-actions-section',
		defaultMessage: 'Quick actions',
		description:
			'Command Palette section name, used to group action commands like Create Issue, change theme',
	},
	personalSettingsSection: {
		id: 'command-palette-integration.controllers.use-register-sections.personal-settings-section',
		defaultMessage: 'Personal settings',
		description:
			'Command Palette section name, used to group personal settings commands change theme, Go to personal settings',
	},
	helpSection: {
		id: 'command-palette-integration.controllers.use-register-sections.help-section',
		defaultMessage: 'Help',
		description:
			'Command Palette section name, used to group help commands like get help, keyboard shortcuts',
	},
	jiraSettingsSection: {
		id: 'command-palette-integration.controllers.use-register-sections.jira-settings-section',
		defaultMessage: 'Jira Settings',
		description:
			'Command Palette section name, used to group settings commands like system settings, project settings, etc',
	},
	atlassianAdminSection: {
		id: 'command-palette-integration.controllers.use-register-sections.atlassian-admin-section',
		defaultMessage: 'Atlassian admin',
		description:
			'Command Palette section name, used to group site admin commands like user management and billing',
	},
	quickSearchSection: {
		id: 'command-palette-integration.controllers.use-register-sections.quick-search-section',
		defaultMessage: 'Search work',
		description:
			'Command Palette section name, used to group search commands like search issues, projects, etc',
	},
});
